module.exports = "/images/af.svg?b32bfa5f207de0182714fbbf4e4cc26e";